import React, { useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaPlus, FaMinus } from "react-icons/fa6";
import { Link, useNavigate, useParams } from "react-router-dom";
import { products } from "../data/products";
import { FaRegStar, FaShareAlt, FaStar } from "react-icons/fa";
import TrendProducts from "../components/TrendProducts";
import RecentView from "../components/RecentView";
import { getALLCategory, getProduct } from "../apis/config";
import { useDispatch } from "react-redux";
import { addToCart } from "../store/slices/CartSlice";
import toast from "react-hot-toast";
import { GrClose } from "react-icons/gr";
import ImageModal from "../components/ImageModel";

const ProductDetail = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState();
  const [added, setAdded] = useState(false);
  const [categorys, setCategorys] = useState([]);
  const [selIndex, setSelIndex] = useState(0);
  const [showImage, setShowImage] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    getProduct(productId)
      .then((res) => setProduct(res.data))
      .catch((err) => console.log(err));
  }, [productId]);

  const [quantity, setQuantity] = useState(1);

  const increaseQuantity = () => {
    setQuantity((prev) => prev + 1);
  };

  const decreaseQuantity = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1)); // prevent going below 1
  };

  useEffect(() => {
    getALLCategory()
      .then((res) => setCategorys(res.data))
      .catch((err) => console.log(err));
  }, []);
  const handleAddProduct = () => {
    if (product.stockStatus === "out of stock") {
      toast.error(`${product.name} is currently out of stock`);
      return;
    }
    dispatch(addToCart({ ...product, quantity }));
    setAdded(true);
    toast.success(`${product.name} added to your cart`);
  };
  const handleBuyProduct = () => {
    localStorage.setItem("lastLoginPath",`/buynow/${product._id}`)
    navigate(`/buynow/${product._id}`);
  };

  const handleShare = () => {
    const productUrl = `${window.location.origin}/products/${product?._id}`;

    if (navigator.share) {
      navigator
        .share({
          title: product?.name,
          text: "Check out this product!",
          url: productUrl,
        })
        .then(() => console.log("Shared successfully!"))
        .catch((error) => toast.error("Share failed."));
    } else {
      // Fallback for browsers that don't support Web Share API
      navigator.clipboard
        .writeText(productUrl)
        .then(() => toast.success("Link copied to clipboard!"))
        .catch(() => toast.error("Failed to copy link."));
    }
  };
  if (!product) {
    return <ProductDetailSkeleton />;
  }


  return (
    <>
      <div className="w-full bg-white">
        {/* Breadcrumb */}
        <div className="p-5 md:px-20 bg-gray-100 text-sm flex justify-between font-medium flex-wrap">
          <span className="text-gray-500 pb-5 md:p-0">Shop</span>

          <div className="flex gap-2 text-gray-500 flex-wrap">
            <span className="hover:text-black cursor-pointer">
              <Link to="/">Home</Link>
            </span>
            <span>/</span>

            {(() => {
              const category = categorys.find(
                (c) => c._id === product.category
              );
              const subCategory = category?.subcategories.find(
                (s) => s._id === product.subCategory
              );
              const type = subCategory?.types.find(
                (t) => t._id === product.type
              );

              return (
                <>
                  {category && (
                    <>
                      <span className="hover:text-black cursor-pointer">
                        <Link to={`/category/${category.name}`}>
                          {category.name}
                        </Link>
                      </span>
                      <span>/</span>
                    </>
                  )}

                  {subCategory && (
                    <>
                      <span className="hover:text-black cursor-pointer">
                        <Link
                          to={`/category/${category.name}/${subCategory.name}`}
                        >
                          {subCategory.name}
                        </Link>
                      </span>
                      <span>/</span>
                    </>
                  )}

                  {type && (
                    <>
                      <span className="hover:text-black cursor-pointer">
                        <Link
                          to={`/category/${category.name}/${subCategory.name}/${type.name}`}
                        >
                          {type.name}
                        </Link>
                      </span>
                      <span>/</span>
                    </>
                  )}
                </>
              );
            })()}

            <span className="text-black font-semibold">{product.name}</span>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex flex-col md:flex-row gap-10 p-5 md:px-20">
          {/* Left: Product Image */}
          <div className="w-full md:w-1/2">
            <div
              className=" aspect-square overflow-hidden rounded-md shadow-sm"
              onClick={() => setShowImage(true)}
            >
              <img
                src={product.images[selIndex]}
                alt={product.name}
                className="w-full h-full"
              />
            </div>
            {product.images.length > 1 && (
              <div className=" p-2 flex items-center gap-3 w-full overflow-x-auto">
                {product.images.map((img, index) => {
                  //  if (index === 0) return null;
                  return (
                    <div
                      className={` min-w-[80px] md:min-w-[100px] h-[80px] md:h-[100px] overflow-hidden rounded-md shadow-sm cursor-pointer border hover:border-primary ${
                        selIndex === index && " border-primary"
                      }`}
                      onClick={() => setSelIndex(index)}
                    >
                      <img
                        src={img}
                        alt={product.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Right: Product Info */}
          <div className="w-full md:w-1/2 space-y-5">
            <p className="text-sm text-gray-500">
              {categorys.find((cate) => cate._id === product.category)?.name}
            </p>

            <h1 className="text-2xl font-bold">{product.name}</h1>

            {/* <div className="flex items-center mt-1  text-gray-600">
            {[1, 2, 3, 4, 5].map((index) =>
              index <= product.rate ? (
                <FaStar key={index} color="#ffa569" />
              ) : (
                <FaRegStar key={index} />
              )
            )}
          </div> */}

            <p
              className="text-gray-600 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: product.description }}
            ></p>

            {/* Size Options */}
            {/* <div>
            <h5 className="font-semibold mb-2">Size</h5>
            <div className="flex gap-3">
              {["XS", "S", "M", "L"].map((size) => (
                <span
                  key={size}
                  className="border border-gray-300 px-4 py-2 text-sm cursor-pointer hover:border-primary transition-all"
                >
                  {size}
                </span>
              ))}
            </div>
          </div> */}

            {/* Color Options */}
            {/* <div>
            <h5 className="font-semibold mb-2">Color</h5>
            <div className="flex gap-4">
              <div className="w-7 h-7 rounded-full bg-green-500 border hover:scale-105 cursor-pointer"></div>
              <div className="w-7 h-7 rounded-full bg-yellow-500 border hover:scale-105 cursor-pointer"></div>
              <div className="w-7 h-7 rounded-full bg-blue-500 border hover:scale-105 cursor-pointer"></div>
              <div className="w-7 h-7 rounded-full bg-gray-500 border hover:scale-105 cursor-pointer"></div>
            </div>
          </div> */}

            {/* Countdown (Static) */}
            {/* <div className="flex gap-3">
            {["Day", "Hour", "Minute", "Second"].map((unit) => (
              <div
                key={unit}
                className="w-14 h-16 bg-gray-100 border border-gray-300 flex flex-col items-center justify-center"
              >
                <span className="text-lg font-bold">00</span>
                <span className="text-xs text-gray-500">{unit}</span>
              </div>
            ))}
          </div> */}

            {/* Price */}
            <div className="flex items-center gap-3 mt-2">
              <span className="line-through text-gray-500 text-sm">
                &#8377; {product.price}
              </span>
              <span className="text-2xl text-primary font-bold">
                &#8377; {product.salePrice}
              </span>
            </div>
            {/* Quantity Selector */}
            <div className="flex items-center border border-gray-300 w-fit">
              <button
                className="p-3 bg-gray-200 hover:bg-gray-300"
                onClick={decreaseQuantity}
              >
                <FaMinus className="text-primary" />
              </button>
              <span className="px-5 py-2 text-gray-700">{quantity}</span>
              <button
                className="p-3 bg-gray-200 hover:bg-gray-300"
                onClick={increaseQuantity}
              >
                <FaPlus className="text-primary" />
              </button>
            </div>

            {/* Add to Cart */}
            {product.stockStatus === "out of stock" ? (
              <button
                className="mt-4 w-full md:w-1/2 border-red-600 border-[1px] py-3 font-semibold rounded transition-all"
                disabled
              >
                Out of stock
              </button>
            ) : (
              <div className=" flex items-center gap-2">
                <button
                  className=" w-full md:w-1/2 border-primary border-[1px] py-3 font-semibold rounded transition-all"
                  onClick={added ? () => navigate("/cart") : handleAddProduct}
                >
                  {added ? "Go to Cart" : "Add to Cart"}
                </button>
                <button
                  className=" w-full md:w-1/2  bg-primary  text-white py-3 font-semibold rounded transition-all"
                  onClick={handleBuyProduct}
                >
                  Buy Now
                </button>
                <button
                  className="w-12 h-12 border border-primary text-primary rounded-md flex justify-center items-center hover:bg-primary hover:text-white"
                  onClick={handleShare}
                  title="Share"
                >
                  <FaShareAlt />
                </button>
              </div>
            )}

            <div className="my-6">
              <h2 className="text-lg font-semibold mb-2">Specifications</h2>
              <table className="w-full text-sm text-left border border-gray-200 rounded overflow-hidden">
                <tbody>
                  {product.attributes?.map((at, index) => (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                    >
                      <td className="py-2 px-4 font-medium text-gray-600 border-b border-gray-200 w-1/3">
                        {at.attribute}
                      </td>
                      <td className="py-2 px-4 text-gray-700 border-b border-gray-200">
                        {at.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-10">
              <h2 className="text-xl font-bold mb-4">
                Frequently Asked Questions
              </h2>
              <div className="space-y-3">
                {product.faqs.map((faq, index) => (
                  <FAQItem
                    key={index}
                    question={faq.question}
                    answer={faq.answer}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <RecentView product={product} />
      {showImage && (
        <ImageModal product={product} onClose={() => setShowImage(false)} />
      )}
    </>
  );
};

export default ProductDetail;

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border rounded-md p-4">
      <button
        onClick={() => setOpen(!open)}
        className="flex justify-between w-full text-left font-medium"
      >
        <span>{question}</span>
        <span>{open ? "-" : "+"}</span>
      </button>
      {open && <p className="mt-2 text-sm text-gray-600">{answer}</p>}
    </div>
  );
};
const ProductDetailSkeleton = () => {
  return (
    <div className="w-full animate-pulse">
      {/* Breadcrumb */}
      <div className="p-5 md:px-20 bg-gray-100 text-sm flex justify-between flex-wrap gap-2">
        <div className="h-4 w-20 bg-gray-300 rounded"></div>
        <div className="flex gap-2">
          <div className="h-4 w-20 bg-gray-300 rounded"></div>
          <div className="h-4 w-4 bg-gray-300 rounded"></div>
          <div className="h-4 w-24 bg-gray-300 rounded"></div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col md:flex-row gap-10 p-5 md:px-20">
        {/* Left: Image */}
        <div className="w-full md:w-1/2 space-y-4">
          <div className="aspect-square bg-gray-300 rounded-md"></div>
          <div className="flex gap-3">
            {[1, 2, 3].map((_, idx) => (
              <div
                key={idx}
                className="w-[80px] md:w-[100px] h-[80px] md:h-[100px] bg-gray-300 rounded-md"
              ></div>
            ))}
          </div>
        </div>

        {/* Right: Info */}
        <div className="w-full md:w-1/2 space-y-4">
          <div className="h-4 w-32 bg-gray-300 rounded"></div>
          <div className="h-6 w-64 bg-gray-300 rounded"></div>
          <div className="h-4 w-48 bg-gray-300 rounded"></div>
          <div className="space-y-2">
            <div className="h-4 w-full bg-gray-300 rounded"></div>
            <div className="h-4 w-full bg-gray-300 rounded"></div>
            <div className="h-4 w-3/4 bg-gray-300 rounded"></div>
          </div>

          {/* Quantity & buttons */}
          <div className="flex gap-2 items-center">
            <div className="h-10 w-10 bg-gray-300 rounded"></div>
            <div className="h-10 w-20 bg-gray-300 rounded"></div>
            <div className="h-10 w-20 bg-gray-300 rounded"></div>
            <div className="h-10 w-10 bg-gray-300 rounded"></div>
          </div>

          {/* Specifications Table */}
          <div className="h-48 bg-gray-200 rounded"></div>

          {/* FAQ */}
          <div className="space-y-2">
            {[1, 2, 3, 4].map((_, idx) => (
              <div key={idx} className="h-12 bg-gray-300 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
